import { render, staticRenderFns } from "./StoreMessage.vue?vue&type=template&id=7d9c6b99&"
import script from "./StoreMessage.vue?vue&type=script&lang=js&"
export * from "./StoreMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\yuichi\\git\\open_coupon\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9c6b99')) {
      api.createRecord('7d9c6b99', component.options)
    } else {
      api.reload('7d9c6b99', component.options)
    }
    module.hot.accept("./StoreMessage.vue?vue&type=template&id=7d9c6b99&", function () {
      api.rerender('7d9c6b99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/StoreMessage.vue"
export default component.exports